export default {
  _name: 'dark',
  _appearance: 'dark',

  background: '#0B0A15',
  border: '#434343',
  overlay: '#28334c',
  content: '#FFFFFF',
  contentSecondary: '#FD40FE',

  surface: '#434343',
  surfaceContent: '#FAFAFA',
  surfaceContentSecondary: '#FAFAFA',
  surfaceContentAuxiliar: '#0B0A15',
  surfaceIcon: '#818181',
  surfaceUnder: '#595959',
  surfaceOpened: '#FD40FE',
  surfaceSelected: '#405071',
  surfaceHighlight: '#405071',
  surfacePressed: '#3f4e6d',
  surfaceInteractive: '#DEFB48',

  feedbackSurface: '#4c5d82',
  feedbackSurfaceContent: '#212B36',
  feedbackSurfaceContentSecondary: '#637381',

  warning: '#ffa410',
  warningSurface: '#656569',
  warningSurfaceContent: '#ffa410',

  info: '#00d2ff',
  infoSurface: '#6F82F5',
  infoSurfaceContent: '#B7C0FA',

  help: '#7C80F2',
  helpContent: '#FFFFFF',
  helpSurface: '#FFFFFF',
  helpSurfaceContent: '#212B36',

  negative: '#FF6969',
  negativeContent: '#FFFFFF',
  negativeSurface: '#655c72',
  negativeSurfaceContent: '#ff5454',

  positive: '#0F2EEE',
  positiveContent: '#FFFFFF',
  positiveSurface: '#35585e',
  positiveSurfaceContent: '#2cc68f',

  badge: '#595959',
  badgeContent: '#F5F5F5',
  badgePressed: '#4c5d82',

  tagIdentifier: '#564090',
  tagIdentifierContent: '#b6a1ff',

  tagNew: '#35585e',
  tagNewContent: '#2cc68f',

  tagIndicator: '#415279',
  tagIndicatorContent: '#00d3ff',

  tagActivity: '#00d2ff',
  tagActivityContent: '#FFFFFF',

  hint: '#6683c3',
  link: '#DEFB48',
  focus: '#DEFB48',
  selected: '#DEFB48',
  selectedContent: '#FFFFFF',
  selectedDisabled: '#212B36',

  disabled: '#3f4e6f',
  disabledContent: '#8497bf',
  disabledIcon: '#6683c3',

  control: '#595959',
  controlBorder: '#262626',
  controlBorderPressed: '#B2C93B',
  controlDisabled: '#3f4e6f',
  controlSurface: '#F9FAFC',
  controlUnder: '#F1F3F7',

  accent: '#DEFB48',
  accentStart: '#32fff5',
  accentEnd: '#08BEE5',
  accentContent: '#FFFFFF',

  floating: '#1c2539',
  floatingContent: '#FFFFFF',

  green: '#DEFB48',
  yellow: '#F7D858',
  red: '#F08658',
  blue: '#0F2EEE',
  brown: '#876559',
  purple: '#FD40FE',
}
